/**
 * Global constants for external links used throughout the application
 */
export const EXTERNAL_LINKS = {
  // Support and Help
  HELP_CENTER: 'https://support.voids.no/',
  
  // Product Information
  CHANGELOG: 'https://support.voids.no/',
  
  // Legal Documents
  TERMS_OF_USE: 'https://voids.no/vilkar-for-bruk/',
  PRIVACY_POLICY: 'https://voids.no/personvern/',
  CANCELLATION_POLICY: 'https://support.voids.no/article/kanselleringsvilkar-for-reservasjoner',
} as const;